// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../CommunityWebPortal/_app/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.calendar-dialog.mx-calendar>div>wc-datepicker>div.wc-datepicker{width:fit-content}", ""]);
// Exports
module.exports = exports;
